import moment from 'moment';

export const productionOrder = () => {
    return {
        branch_office_id: null,
        voucher_type_id: null,
        prefix: null,
        consecutive: null,
        date: moment().format('YYYY-MM-DD'),
        contact_id: null,
        delivery_date: moment().add(1, 'month').format('YYYY-MM-DD'),
        finished_product_id: null,
        expiration_date: moment().add(1, 'month').format('YYYY-MM-DD'),
        quantity_to_produce: null,
        quantity_produced: 0,
        quantity_pending: 0,
        total_production_cost: 0,
        production_cost_applied: 0,
        pending_production_cost: 0,
        production_cost: 0,
        parameter_state_id: null,
        observations: null,
        user_creator_id: null,
        user_last_modified_id: null,
        operation_id: null,
        contact: {},
        branch_office: {},
        voucher_type: {},
        finished_product: {},
        parameter_state: {},
        user_creator: {},
        user_last_modified: {},
        documents_products: [],
        production_order_operations: []
    };
};

const filters = () => {
    return {
        dates: [
            moment().add(-1, 'month').add(1, 'day').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
        ],
        parameter_state_id: null,
        per_page: 30,
        page: 1
    };
};

export default {
    production_orders: {
        data: []
    },
    document_product: {},
    production_order: productionOrder(),
    filters: filters(),
    preloader: false,
    editing: false,
    contacts: [],
    branch_offices: [],
    branch_offices_warehouses: [],
    products: [],
    production_order_operations: [],
    branch_office_main: null,
    branch_office_warehouse_conditioning: null,
    branch_office_warehouse_available: null,
    operations: [],
    states: [],
    pdf: null,
    modal_pdf: {show: false},
    get_data: true,
    lots: {
        columns: [
            {
                name: 'Lote',
                field: 'lot'
            },
            {
                name: 'Fech-Venc',
                field: 'due_date'
            },
            {
                name: 'Existencia',
                field: 'stock'
            },
            {
                name: 'Cant',
                field: 'quantity',
                editable: true,
                format: 'number'
            }
        ],
        data: []
    },
    modal_lots: {
        show: false
    }
};



// WEBPACK FOOTER //
// ./src/modules/conditioning/state.js